import React from "react";

const CTA = ({
  title = "Siap Buat Suara Acaramu Bersuara?",
  description = "Klik tombol di bawah untuk booking sekarang. Cukup kirim lokasi & tanggal, kami yang urus sisanya.",
  buttonText = "Booking Sound System Sekarang",
  onClick = () => {},
}) => (
  <div className="bg-zinc-900 text-white p-6 rounded-2xl text-center mt-6">
    <h3 className="text-xl font-bold mb-2" dangerouslySetInnerHTML={{ __html: title }} />
    <p className="text-sm mb-4" dangerouslySetInnerHTML={{ __html: description }} />
    <button
      onClick={onClick}
      title={title + ' ' + buttonText}
      className="bg-white text-black px-6 py-2 rounded-xl font-semibold shadow hover:bg-zinc-100 transition-all"
      dangerouslySetInnerHTML={{ __html: buttonText }}
    />
  </div>
);

export default CTA;